import { render, staticRenderFns } from "./FounderConsultManagementHistory.vue?vue&type=template&id=35d5bbaa&"
import script from "./FounderConsultManagementHistory.vue?vue&type=script&lang=ts&"
export * from "./FounderConsultManagementHistory.vue?vue&type=script&lang=ts&"
import style0 from "./FounderConsultManagementHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports